import './home.scss'
import React, { useEffect } from 'react'
import { HomeAmount } from './amount/homeAmount'
import { useStepper } from '../../features/stepper'
import { QrCodePayment } from './qrcode/qrcode'
import { useAppSelector } from '../../features'
import { getPaymentCompleted } from '../../store/TransactionSlice'
import { FinishTransaction } from './finishTransaction/finishTransaction'

export const Home: React.FC= () => {
    
    useEffect(() => {
        const hideAddressBar = () => {
          window.scrollTo(0, 1);
        };
    
        hideAddressBar();
      }, []);      
    const [step, increaseStep, decreaseStep, setStep] = useStepper(0);

    const paymentIsCompleted = useAppSelector(getPaymentCompleted);
    
    const Component = [
        HomeAmount,
        QrCodePayment
    ][step];

    if (paymentIsCompleted) return <FinishTransaction increaseStep={increaseStep} decreaseStep={decreaseStep} />;

    return <Component increaseStep={increaseStep} decreaseStep={decreaseStep}/>
}